import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Sourav Mohanty</span>,{" "}
            a <span className="purple">Cloud & DevOps Engineer</span> from{" "}
            <span className="purple">Bhubaneswar, Odisha, India</span>.
            <br />
            <br />
            Currently working at <span className="purple">Unloq®</span>, a UK-based{" "}
            AI company, where I'm building{" "}
            <span className="purple">cloud infrastructure and DevOps pipelines</span>{" "}
            for strategic intelligence platforms used by enterprise clients.{" "}
            I work with <span className="purple">AWS, Terraform, Docker, Kubernetes</span>,{" "}
            and Python to build scalable, secure systems.
            <br />
            <br />
            I'm also pursuing M.Tech in <span className="purple">Cloud Computing</span>{" "}
            at <span className="purple">IIT Patna</span>, where I'm researching{" "}
            cloud-native security automation and infrastructure optimization.
            <br />
            <br />
            Previously, I was a{" "}
            <span className="purple">Research & Development Intern at ISRO</span>{" "}
            in Ahmedabad, where I worked on satellite monitoring systems,{" "}
            migrating from Arduino to Raspberry Pi and improving mission{" "}
            efficiency by 30% through automated data processing.
            <br />
            <br />
            I completed my B.Tech in Computer Science from{" "}
            <span className="purple">GITA Autonomous College (2024)</span>,{" "}
            where I developed strong foundations in distributed systems,{" "}
            cloud architecture, and software engineering.
            <br />
            <br />
            🏆 I'm a <span className="purple">Rising Star Award 2025</span> winner{" "}
            (MIECA) and secured <span className="purple">Top 10</span> at the{" "}
            <span className="purple">Agent.ai Hackathon 2024</span>.
            <br />
            <br />
            My technical expertise includes:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> <strong>Cloud & DevOps:</strong> AWS (EC2, S3, RDS, Lambda, VPC),
              Terraform, Docker, Kubernetes, Jenkins, GitHub Actions
            </li>
            <li className="about-activity">
              <ImPointRight /> <strong>Programming:</strong> Python, Java, Bash, SQL, JavaScript
            </li>
            <li className="about-activity">
              <ImPointRight /> <strong>Backend Development:</strong> Spring Boot, Node.js,
              Express, REST APIs, MySQL
            </li>
            <li className="about-activity">
              <ImPointRight /> <strong>Security & Monitoring:</strong> Container security,
              vulnerability scanning, CloudWatch, cost optimization
            </li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            My recent projects include:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> <span className="purple">Docker Security Scanner</span> with{" "}
              automated remediation (91% vulnerability reduction)
            </li>
            <li className="about-activity">
              <ImPointRight /> <span className="purple">AWS Cost Analyzer</span> with{" "}
              Slack alerts (identified $1,530 yearly savings)
            </li>
            <li className="about-activity">
              <ImPointRight /> <span className="purple">Terraform Drift Detector</span> with{" "}
              auto-fix generation and CI/CD integration
            </li>
            <li className="about-activity">
              <ImPointRight /> <span className="purple">CI/CD pipelines</span> reducing{" "}
              deployment time by 95%
            </li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            <br />
            Apart from tech, here are a few things I enjoy:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Chess & Strategy Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Technical Blogs on Cloud & DevOps
            </li>
            <li className="about-activity">
              <ImPointRight /> Contributing to Open Source Projects
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring New Cloud Technologies & AI/ML Tools
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Build infrastructure that scales, secure what matters, automate everything else."
          </p>
          <footer className="blockquote-footer">Sourav</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;